/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralLookup } from '../../models/general-lookup';
import { GeneralLookupDto } from '../../models/general-lookup-dto';

export interface UpdateGeneralLookup$Params {
  generalLookupId: number;
      body: GeneralLookupDto
}

export function updateGeneralLookup(http: HttpClient, rootUrl: string, params: UpdateGeneralLookup$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralLookup>> {
  const rb = new RequestBuilder(rootUrl, updateGeneralLookup.PATH, 'put');
  if (params) {
    rb.path('generalLookupId', params.generalLookupId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralLookup>;
    })
  );
}

updateGeneralLookup.PATH = '/api/lookuptable/{generalLookupId}';
